export default {
    methods: {
        findOptionEntry(options, value) {
            for (var i in options) {
                if (options[i].value == value) {
                    return options[i];
                }
            }
            return null;
        }
    }
}